export default function ArrowRight({ color }: { color: string }) {
  return <path d="M8,0 l-16,-8 q4,8 0,16 l16,-8" fill={color} />;
}
